import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { QcCustomerTagComponent } from '../qc/qc-customer-tag/qc-customer-tag.component';
import { QcCustomerEntryComponent } from '../qc/qc-customer-entry/qc-customer-entry.component';

@Component({
  selector: 'app-grid-detail',
  templateUrl: './grid-detail.component.html',
  styleUrls: ['./grid-detail.component.scss']
})
export class GridDetailComponent extends GridBaseCase {
  @ViewChild("qcTag") qcTag: QcCustomerTagComponent;
  @ViewChild("qcTagEntry") qcTagEntry: QcCustomerEntryComponent;
  constructor() { super(); }
  A2submit(param,type:any = 0) {
    let that = this;
    switch (param) {
      case "qcTag":
        that.qcTag.EventSubmitClick();
        break;
        case "qcTagEntry":
        that.qcTagEntry.EventSubmitClick(type);
        break;
    }
  }
}
